import { Box, FormLabel } from "@mui/material";
import TooltipPopover from "../../../../components/shared/others/TooltipPopover";

const TooltipFine = () => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <FormLabel sx={{ color: 'text.primary' }}><b>Multa (R$)</b></FormLabel>
            <TooltipPopover>
                <ul>
                    <li>Penalidade fixa por atraso, geralmente um percentual do valor total da dívida.</li>
                    <li>É cobrada uma única vez, no momento do atraso.</li>
                    <li>Deve estar expressamente prevista no contrato para ser cobrada legalmente.</li>
                </ul>
                <p>
                    O preenchimento do valor da multa na criação da fatura tem o objetivo de registro.
                    O Produttivo não calcula automaticamente o valor a ser pago em uma fatura atrasada.
                </p>
            </TooltipPopover>
        </Box>
    )
}

export default TooltipFine;